import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press18',
  templateUrl: './notice-press18.component.html',
  styleUrls: ['./notice-press18.component.scss']
})
export class NoticePress18Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
